import { environment } from 'src/environments/environment';
import { OEEnvironment } from 'src/environments/environment.type';
import { ConfigurationServiceMock } from 'src/testing/mocks/configuration.service.mock';
import { ConfigurationService } from '../services/api/configuration/configuration.service';
import { GenericStorageService } from '../services/storage/generic-storage.service';
import { MockStorage } from '../../testing/mock-switch/mock-switch.component';

export function configServiceFactory(mockStorage: GenericStorageService<MockStorage>) {
	const storageValues = mockStorage.value();
	if (environment.appMeta.env === OEEnvironment.DEV && storageValues?.mockMode) {
		return ConfigurationServiceMock.createConfigurationServiceMock(
			storageValues.values || [],
		) as any;
	}
	return new ConfigurationService();
}
